import { PROTOTYPE_PREFIX } from 'prototypes/securedCard/prototypeAssumptions';
import { StoryMilestone } from 'prototypes/securedCard/types';

export enum PrototypePath {
  Welcome = '/prototypes/secured-card',
  Paycheck = '/prototypes/secured-card/paycheck',
  Growth = '/prototypes/secured-card/grows',
  Spend = '/prototypes/secured-card/spend',
  Keep = '/prototypes/secured-card/keep',
  Dashboard = '/prototypes/secured-card/dashboard',
  Transactions = '/prototypes/secured-card/transactions',
  Landing = '/prototypes/secured-card/landing',
}

export interface FlowStep {
  id: string;
  label: string;
  path: PrototypePath;
  required: StoryMilestone;
}

export const FLOW_STEPS: FlowStep[] = [
  { id: 'paycheck', label: 'Paycheck', path: PrototypePath.Paycheck, required: StoryMilestone.Started },
  { id: 'grows', label: 'Grows', path: PrototypePath.Growth, required: StoryMilestone.PaycheckSet },
  { id: 'spend', label: 'Spend', path: PrototypePath.Spend, required: StoryMilestone.GrowthSeen },
  { id: 'keep', label: 'Keep', path: PrototypePath.Keep, required: StoryMilestone.PurchasePaid },
  { id: 'card', label: 'Card', path: PrototypePath.Dashboard, required: StoryMilestone.Complete },
];

export const isSecuredCardPrototypePath = (pathname: string): boolean =>
  pathname === PROTOTYPE_PREFIX || pathname.startsWith(`${PROTOTYPE_PREFIX}/`);

export const pathForMilestone = (milestone: StoryMilestone): PrototypePath => {
  switch (milestone) {
    case StoryMilestone.NotStarted:
      return PrototypePath.Welcome;
    case StoryMilestone.Started:
      return PrototypePath.Paycheck;
    case StoryMilestone.PaycheckSet:
      return PrototypePath.Growth;
    case StoryMilestone.GrowthSeen:
      return PrototypePath.Spend;
    case StoryMilestone.PurchasePaid:
      return PrototypePath.Keep;
    case StoryMilestone.Complete:
      return PrototypePath.Dashboard;
    default:
      throw new Error(`Unknown story milestone: ${milestone}`);
  }
};
